import { ref } from 'vue';

const STORAGE_KEY = 'theme';

const theme = ref(localStorage.getItem(STORAGE_KEY) || 'dark');

const applyTheme = (value) => {
  document.documentElement.classList.toggle('dark', value === 'dark');
};

// Apply immediately so the correct theme is set before any component mounts.
applyTheme(theme.value);

const setTheme = (value) => {
  theme.value = value;
  localStorage.setItem(STORAGE_KEY, value);
  applyTheme(value);
};

const toggleTheme = () => {
  setTheme(theme.value === 'dark' ? 'light' : 'dark');
};

export function useTheme() {
  return { theme, setTheme, toggleTheme };
}
